export interface Chapter {
  id: number;
  title: string;
  updateTime: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  description: string;
  status: '连载中' | '已完结';
  updateTime: string;
  latestChapter: string;
  rating: number;
  views: string;
  chapters: Chapter[];
  tags: string[];
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '韩漫', slug: 'hanman', icon: 'ri-global-line', count: 1280 },
  { name: '日漫', slug: 'riman', icon: 'ri-sun-line', count: 3560 },
  { name: '国漫', slug: 'guoman', icon: 'ri-ancient-gate-line', count: 2100 },
  { name: '耽美', slug: 'danmei', icon: 'ri-hearts-line', count: 890 },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', count: 1560 },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', count: 2340 },
  { name: '冒险', slug: 'maoxian', icon: 'ri-compass-line', count: 1890 },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 1120 },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 760 },
  { name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line', count: 650 },
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line', count: 1980 },
  { name: '古风', slug: 'gufeng', icon: 'ri-scissors-line', count: 870 },
];

export const hotComics: Comic[] = [
  {
    id: 1,
    title: '绝世神医在都市',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20handsome%20doctor%20in%20modern%20city%20with%20mystical%20glowing%20hands%2C%20dramatic%20lighting%2C%20clean%20composition%2C%20professional%20manga%20illustration%20with%20bold%20lines%20and%20vibrant%20warm%20colors&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    description: '一代神医意外穿越到现代都市，凭借绝世医术横扫四方，各路美女纷至沓来。他左手治病救人，右手惩恶扬善，在都市中掀起一场惊天波澜。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第287话 终极对决',
    rating: 9.6,
    views: '1280万',
    chapters: [],
    tags: ['都市', '玄幻', '逆袭', '热血'],
  },
  {
    id: 2,
    title: '霸道总裁的契约新娘',
    author: '七月雪',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20beautiful%20woman%20in%20wedding%20dress%20with%20a%20cold%20handsome%20man%20in%20suit%2C%20romantic%20dramatic%20atmosphere%2C%20soft%20warm%20lighting%2C%20clean%20manga%20illustration%20with%20elegant%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '韩漫',
    categorySlug: 'hanman',
    description: '为了拯救家族企业，她被迫嫁给冷酷无情的霸道总裁。原以为是地狱般的婚姻，却不想冰山总裁竟对她百般宠爱。契约婚姻能否变成真爱？',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第156话 真心告白',
    rating: 9.3,
    views: '980万',
    chapters: [],
    tags: ['恋爱', '总裁', '契约婚姻', '甜宠'],
  },
  {
    id: 3,
    title: '剑与魔法之异世界转生',
    author: '星野琉璃',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20young%20warrior%20holding%20a%20glowing%20sword%20in%20a%20fantasy%20world%20with%20magic%20effects%2C%20epic%20adventure%20atmosphere%2C%20warm%20golden%20lighting%2C%20detailed%20manga%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '日漫',
    categorySlug: 'riman',
    description: '普通高中生意外穿越到剑与魔法的异世界，获得了前所未有的强大力量。他必须在剑术与魔法之间找到平衡，拯救这个濒临毁灭的奇幻世界。',
    status: '已完结',
    updateTime: '2026-07-28',
    latestChapter: '第320话 终章·新的开始',
    rating: 9.8,
    views: '2100万',
    chapters: [],
    tags: ['奇幻', '冒险', '异世界', '战斗'],
  },
  {
    id: 4,
    title: '校园恋爱攻防战',
    author: '小甜饼',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20two%20high%20school%20students%20a%20boy%20and%20a%20girl%20blushing%20under%20cherry%20blossom%20tree%2C%20sweet%20romantic%20atmosphere%2C%20soft%20pink%20warm%20lighting%2C%20clean%20shojo%20manga%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    description: '学霸校草与学渣少女因为一次意外成为同桌，从互相看不顺眼到暗生情愫。校园里的青涩恋爱，甜到让人心动不已。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第98话 意外的吻',
    rating: 9.4,
    views: '1560万',
    chapters: [],
    tags: ['恋爱', '校园', '甜宠', '青春'],
  },
  {
    id: 5,
    title: '暗夜侦探事务所',
    author: '夜幕降临',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20mysterious%20detective%20in%20trench%20coat%20standing%20in%20dark%20alley%20with%20city%20lights%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20suspenseful%20manga%20illustration%20with%20moody%20warm%20tones&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '韩漫',
    categorySlug: 'hanman',
    description: '前任刑警开设私人侦探事务所，接手各类离奇案件。每一桩案件背后都隐藏着不为人知的秘密，他在追寻真相的道路上越陷越深。',
    status: '连载中',
    updateTime: '2026-08-02',
    latestChapter: '第203话 最后的证人',
    rating: 9.5,
    views: '890万',
    chapters: [],
    tags: ['悬疑', '推理', '都市', '探案'],
  },
  {
    id: 6,
    title: '魔王大人想退休',
    author: '懒散的猫',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20funny%20demon%20lord%20in%20casual%20clothes%20relaxing%20with%20coffee%2C%20comedy%20slice%20of%20life%20atmosphere%2C%20warm%20cozy%20lighting%2C%20lighthearted%20manga%20illustration%20with%20humorous%20expression&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '日漫',
    categorySlug: 'riman',
    description: '统治魔界千年的魔王大人终于厌倦了战争，决定跑到人间退休养老。然而人间的生活远比他想象中更加麻烦——尤其是隔壁搬来了一位勇者后代！',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第145话 邻居的秘密',
    rating: 9.2,
    views: '760万',
    chapters: [],
    tags: ['搞笑', '奇幻', '日常', '反差萌'],
  },
  {
    id: 7,
    title: '修仙大佬在校园',
    author: '玄机子',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20young%20cultivator%20in%20school%20uniform%20with%20floating%20ancient%20runes%20around%2C%20modern%20school%20background%20with%20mystical%20elements%2C%20dynamic%20warm%20lighting%2C%20action%20manga%20illustration&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    description: '修炼千年的修仙大佬渡劫失败，灵魂意外附身到一名普通高中生身上。从此校园里多了一个能御剑飞行、炼丹画符的奇葩学生。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第312话 天劫降临',
    rating: 9.7,
    views: '1890万',
    chapters: [],
    tags: ['玄幻', '校园', '修仙', '搞笑'],
  },
  {
    id: 8,
    title: '花美男咖啡厅',
    author: '蜜糖罐子',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20handsome%20male%20baristas%20in%20a%20cozy%20cafe%20with%20warm%20ambient%20lighting%2C%20romantic%20charming%20atmosphere%2C%20beautiful%20character%20design%2C%20clean%20manga%20illustration%20with%20soft%20warm%20colors&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '耽美',
    categorySlug: 'danmei',
    description: '失业女孩误打误撞进入一家全是花美男的咖啡厅工作。每位咖啡师都有自己独特的故事，而她在咖啡香气中逐渐找到了属于自己的爱情。',
    status: '已完结',
    updateTime: '2026-07-15',
    latestChapter: '第180话 永远的咖啡香',
    rating: 9.1,
    views: '670万',
    chapters: [],
    tags: ['恋爱', '都市', '美男', '治愈'],
  },
];

export const latestUpdates: Comic[] = [
  {
    id: 9,
    title: '星际殖民时代',
    author: '宇宙旅人',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20spaceship%20captain%20in%20futuristic%20armor%20with%20stars%20and%20planets%20in%20background%2C%20sci-fi%20adventure%20atmosphere%2C%20dramatic%20space%20lighting%2C%20detailed%20mecha%20manga%20illustration&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '科幻',
    categorySlug: 'kehuan',
    description: '公元3000年，人类开启星际殖民时代。年轻的舰长率领星舰探索未知宇宙，在浩瀚星海中遭遇外星文明，揭开宇宙最深处的秘密。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第89话 未知信号',
    rating: 9.0,
    views: '430万',
    chapters: [],
    tags: ['科幻', '冒险', '星际', '机甲'],
  },
  {
    id: 10,
    title: '九尾狐的报恩',
    author: '山海经',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20beautiful%20nine-tailed%20fox%20spirit%20in%20traditional%20Chinese%20hanfu%20dress%20with%20ancient%20palace%20background%2C%20mystical%20fantasy%20atmosphere%2C%20warm%20golden%20lighting%2C%20elegant%20oriental%20manga%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '古风',
    categorySlug: 'gufeng',
    description: '书生救下一只受伤的白狐，不料白狐竟是修炼千年的九尾狐仙。为报救命之恩，狐仙化作绝美女子来到书生身边，一段跨越人妖界限的旷世奇缘就此展开。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第67话 狐仙真身',
    rating: 9.6,
    views: '560万',
    chapters: [],
    tags: ['古风', '玄幻', '仙侠', '爱情'],
  },
  {
    id: 11,
    title: '食戟之灵异食堂',
    author: '深夜食客',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20chef%20cooking%20with%20supernatural%20flames%20in%20a%20mysterious%20restaurant%2C%20delicious%20food%20with%20magical%20effects%2C%20warm%20appetizing%20atmosphere%2C%20detailed%20food%20manga%20illustration&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '日漫',
    categorySlug: 'riman',
    description: '只在午夜开门的神秘食堂，老板能用料理看见客人内心深处的愿望。每一道菜都是一段故事，每一位食客都有自己的秘密。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第134话 记忆中的味道',
    rating: 9.3,
    views: '720万',
    chapters: [],
    tags: ['美食', '治愈', '奇幻', '日常'],
  },
  {
    id: 12,
    title: '武林高手在现代',
    author: '江湖老炮',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20martial%20artist%20in%20traditional%20clothing%20fighting%20in%20modern%20city%20street%2C%20action%20dynamic%20atmosphere%2C%20dramatic%20warm%20lighting%2C%20intense%20fighting%20manga%20illustration&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    description: '隐居深山的武林世家传人初次来到现代都市，一身绝世武功在钢筋水泥丛林中闹出无数笑话，也引来各方势力的觊觎。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第256话 古武vs现代',
    rating: 9.4,
    views: '1450万',
    chapters: [],
    tags: ['热血', '都市', '武侠', '搞笑'],
  },
  {
    id: 13,
    title: '恋爱吧！电竞大神',
    author: '指尖微光',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20cool%20esports%20player%20with%20headset%20and%20gaming%20gear%2C%20neon%20cyber%20vibe%20atmosphere%2C%20energetic%20dynamic%20lighting%2C%20stylish%20modern%20manga%20illustration%20with%20gaming%20theme&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    category: '韩漫',
    categorySlug: 'hanman',
    description: '业余游戏主播意外排到了职业电竞大神，两人在游戏里配合默契。当线上搭档走进现实，一段甜蜜又刺激的电竞恋爱故事开始了。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第78话 线下见面',
    rating: 9.2,
    views: '890万',
    chapters: [],
    tags: ['恋爱', '电竞', '都市', '甜宠'],
  },
  {
    id: 14,
    title: '破晓之刃',
    author: '暗影刺客',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20stealthy%20ninja%20assassin%20in%20dark%20cloak%20with%20glowing%20dagger%2C%20moonlit%20night%20atmosphere%2C%20mysterious%20dramatic%20shadows%2C%20intense%20action%20manga%20illustration&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    category: '冒险',
    categorySlug: 'maoxian',
    description: '在一个被黑暗势力笼罩的王国中，身怀绝技的少年刺客踏上了复仇之路。但他逐渐发现，自己手中的利刃也许可以成为拯救世界的希望。',
    status: '已完结',
    updateTime: '2026-07-20',
    latestChapter: '第195话 黎明降临',
    rating: 9.5,
    views: '1120万',
    chapters: [],
    tags: ['冒险', '战斗', '奇幻', '热血'],
  },
  {
    id: 15,
    title: '我的邻居是神明',
    author: '云端漫步',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20casual%20deity%20character%20in%20everyday%20apartment%20setting%20with%20divine%20glowing%20aura%2C%20slice%20of%20life%20comedy%20atmosphere%2C%20warm%20cozy%20lighting%2C%20heartwarming%20manga%20illustration&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    description: '搬进新公寓的普通上班族发现隔壁住着一位退休神明。这位神明大人不仅爱追剧吃零食，还经常用法力帮倒忙，把日常生活搅得天翻地覆。',
    status: '连载中',
    updateTime: '2026-08-02',
    latestChapter: '第56话 神明的烦恼',
    rating: 9.1,
    views: '510万',
    chapters: [],
    tags: ['搞笑', '日常', '奇幻', '治愈'],
  },
  {
    id: 16,
    title: '深海密码',
    author: '深渊凝视',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20diver%20discovering%20ancient%20ruins%20underwater%20with%20mysterious%20glowing%20symbols%2C%20deep%20ocean%20atmosphere%2C%20eerie%20beautiful%20lighting%2C%20suspenseful%20manga%20illustration&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    description: '海洋考古队在海底发现一座史前文明遗迹，遗迹中的神秘符号暗示着人类起源的惊天秘密。随着调查深入，队员们接连遭遇无法解释的超自然现象。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第42话 深渊之门',
    rating: 9.4,
    views: '380万',
    chapters: [],
    tags: ['悬疑', '科幻', '冒险', '深海'],
  },
];

export const rankingComics: Comic[] = [
  {
    id: 3,
    title: '剑与魔法之异世界转生',
    author: '星野琉璃',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20young%20warrior%20holding%20a%20glowing%20sword%20in%20a%20fantasy%20world%20with%20magic%20effects%2C%20epic%20adventure%20atmosphere%2C%20warm%20golden%20lighting%2C%20detailed%20manga%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '日漫',
    categorySlug: 'riman',
    description: '',
    status: '已完结',
    updateTime: '2026-07-28',
    latestChapter: '第320话',
    rating: 9.8,
    views: '2100万',
    chapters: [],
    tags: ['奇幻', '冒险'],
  },
  {
    id: 7,
    title: '修仙大佬在校园',
    author: '玄机子',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20young%20cultivator%20in%20school%20uniform%20with%20floating%20ancient%20runes%20around%2C%20modern%20school%20background%20with%20mystical%20elements%2C%20dynamic%20warm%20lighting%2C%20action%20manga%20illustration&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    description: '',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第312话',
    rating: 9.7,
    views: '1890万',
    chapters: [],
    tags: ['玄幻', '校园'],
  },
  {
    id: 1,
    title: '绝世神医在都市',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20handsome%20doctor%20in%20modern%20city%20with%20mystical%20glowing%20hands%2C%20dramatic%20lighting%2C%20clean%20composition%2C%20professional%20manga%20illustration%20with%20bold%20lines%20and%20vibrant%20warm%20colors&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    description: '',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第287话',
    rating: 9.6,
    views: '1280万',
    chapters: [],
    tags: ['都市', '玄幻'],
  },
  {
    id: 10,
    title: '九尾狐的报恩',
    author: '山海经',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20beautiful%20nine-tailed%20fox%20spirit%20in%20traditional%20Chinese%20hanfu%20dress%20with%20ancient%20palace%20background%2C%20mystical%20fantasy%20atmosphere%2C%20warm%20golden%20lighting%2C%20elegant%20oriental%20manga%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '古风',
    categorySlug: 'gufeng',
    description: '',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第67话',
    rating: 9.6,
    views: '560万',
    chapters: [],
    tags: ['古风', '玄幻'],
  },
  {
    id: 5,
    title: '暗夜侦探事务所',
    author: '夜幕降临',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20mysterious%20detective%20in%20trench%20coat%20standing%20in%20dark%20alley%20with%20city%20lights%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20suspenseful%20manga%20illustration%20with%20moody%20warm%20tones&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '韩漫',
    categorySlug: 'hanman',
    description: '',
    status: '连载中',
    updateTime: '2026-08-02',
    latestChapter: '第203话',
    rating: 9.5,
    views: '890万',
    chapters: [],
    tags: ['悬疑', '推理'],
  },
  {
    id: 14,
    title: '破晓之刃',
    author: '暗影刺客',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20stealthy%20ninja%20assassin%20in%20dark%20cloak%20with%20glowing%20dagger%2C%20moonlit%20night%20atmosphere%2C%20mysterious%20dramatic%20shadows%2C%20intense%20action%20manga%20illustration&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    category: '冒险',
    categorySlug: 'maoxian',
    description: '',
    status: '已完结',
    updateTime: '2026-07-20',
    latestChapter: '第195话',
    rating: 9.5,
    views: '1120万',
    chapters: [],
    tags: ['冒险', '战斗'],
  },
  {
    id: 4,
    title: '校园恋爱攻防战',
    author: '小甜饼',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20two%20high%20school%20students%20a%20boy%20and%20a%20girl%20blushing%20under%20cherry%20blossom%20tree%2C%20sweet%20romantic%20atmosphere%2C%20soft%20pink%20warm%20lighting%2C%20clean%20shojo%20manga%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    description: '',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第98话',
    rating: 9.4,
    views: '1560万',
    chapters: [],
    tags: ['恋爱', '校园'],
  },
  {
    id: 12,
    title: '武林高手在现代',
    author: '江湖老炮',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20martial%20artist%20in%20traditional%20clothing%20fighting%20in%20modern%20city%20street%2C%20action%20dynamic%20atmosphere%2C%20dramatic%20warm%20lighting%2C%20intense%20fighting%20manga%20illustration&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    description: '',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第256话',
    rating: 9.4,
    views: '1450万',
    chapters: [],
    tags: ['热血', '都市'],
  },
  {
    id: 16,
    title: '深海密码',
    author: '深渊凝视',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20diver%20discovering%20ancient%20ruins%20underwater%20with%20mysterious%20glowing%20symbols%2C%20deep%20ocean%20atmosphere%2C%20eerie%20beautiful%20lighting%2C%20suspenseful%20manga%20illustration&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    description: '',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第42话',
    rating: 9.4,
    views: '380万',
    chapters: [],
    tags: ['悬疑', '科幻'],
  },
  {
    id: 2,
    title: '霸道总裁的契约新娘',
    author: '七月雪',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20beautiful%20woman%20in%20wedding%20dress%20with%20a%20cold%20handsome%20man%20in%20suit%2C%20romantic%20dramatic%20atmosphere%2C%20soft%20warm%20lighting%2C%20clean%20manga%20illustration%20with%20elegant%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '韩漫',
    categorySlug: 'hanman',
    description: '',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第156话',
    rating: 9.3,
    views: '980万',
    chapters: [],
    tags: ['恋爱', '总裁'],
  },
];

export const allComics: Comic[] = [
  ...hotComics,
  ...latestUpdates,
];